/* ============================================================
   RAToM Europe — theme.js  (Chalk White edition)
   ============================================================ */
(function () {
  'use strict';

  // ── Toast ────────────────────────────────────────────────
  function showToast(msg, type) {
    var el = document.getElementById('cart-toast');
    if (!el) return;
    el.className = 'toast toast--' + (type || 'success');
    var msgEl = document.getElementById('cart-toast-msg');
    if (msgEl) msgEl.textContent = msg;
    el.classList.add('show');
    setTimeout(function () { el.classList.remove('show'); }, 2800);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-badge').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-empty', count === 0 ? 'true' : 'false');
    });
  }

  // ── Qty buttons ──────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn');
    if (!btn) return;

    var action = btn.dataset.action;
    var key    = btn.dataset.key;

    // Cart page item
    if (key) {
      var inp = document.querySelector('.cart-qty-input[data-key="' + key + '"]');
      if (!inp) return;
      var val = Math.max(0, parseInt(inp.value) + (action === 'increase' ? 1 : -1));
      inp.value = val;
      updateCartItem(key, val);
      return;
    }

    // Product page
    var pqty = document.getElementById('product-qty');
    if (!pqty) return;
    var pval = parseInt(pqty.value) || 1;
    pqty.value = action === 'increase' ? pval + 1 : Math.max(1, pval - 1);
  });

  // ── Cart item update ─────────────────────────────────────
  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);

      if (quantity === 0) {
        var row = document.querySelector('.cart-item[data-item-key="' + key + '"]');
        if (row) row.remove();
      }

      if (cart.item_count === 0) {
        location.reload();
        return;
      }

      // Update each line item price
      cart.items.forEach(function(item) {
        var row = document.querySelector('.cart-item[data-item-key="' + item.key + '"]');
        if (!row) return;
        var priceEl = row.querySelector('.cart-item__price');
        if (priceEl) priceEl.textContent = formatMoney(item.line_price);
        // Update summary row
        var summaryRows = document.querySelectorAll('.cart-summary__row');
        summaryRows.forEach(function(r) {
          var label = r.querySelector('span:first-child');
          if (label && label.textContent.indexOf(item.product_title) !== -1) {
            var val = r.querySelector('span:last-child');
            if (val) val.textContent = formatMoney(item.line_price);
          }
        });
      });

      // Update total
      var totalEl = document.querySelector('.cart-summary__row--total .value');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price) + ' EUR';
    })
    .catch(function () { showToast('Something went wrong', 'error'); });
  }

  // ── Remove buttons ───────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-item__remove');
    if (btn && btn.dataset.key) updateCartItem(btn.dataset.key, 0);
  });

  // ── Product form (AJAX add to cart) ─────────────────────
  var form = document.getElementById('product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('add-to-cart-btn');
      var orig = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span style="opacity:.55">Adding…</span>';

      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: fd.get('id'), quantity: parseInt(fd.get('quantity')) || 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        showToast('Added to cart', 'success');
        btn.innerHTML = orig;
        btn.disabled = false;
      })
      .catch(function () {
        showToast('Could not add to cart', 'error');
        btn.innerHTML = orig;
        btn.disabled = false;
      });
    });
  }

  // ── Image gallery ────────────────────────────────────────
  document.querySelectorAll('.product-media__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-media__thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = document.getElementById('product-main-image');
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
      }
    });
  });

})();

/* ── Also Like: mobile dot indicators ── */
(function() {
  var track = document.getElementById('also-like-track');
  var dotsEl = document.getElementById('also-like-dots');
  if (!track || !dotsEl) return;

  var cards = track.querySelectorAll('.also-like__card');
  if (!cards.length) return;

  // Build dots
  cards.forEach(function(_, i) {
    var dot = document.createElement('span');
    dot.className = 'also-like__dot' + (i === 0 ? ' active' : '');
    dotsEl.appendChild(dot);
  });

  var dots = dotsEl.querySelectorAll('.also-like__dot');

  track.addEventListener('scroll', function() {
    var index = Math.round(track.scrollLeft / track.offsetWidth);
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === index);
    });
  }, { passive: true });
})();



/* ── Page transition (desktop only) ── */
(function() {
  if ('ontouchstart' in window) return; // skip on touch devices
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto') || href.startsWith('tel')) return;
    if (link.target === '_blank') return;
    if (href.startsWith('http') && !href.includes(window.location.hostname)) return;
    e.preventDefault();
    document.body.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
    document.body.style.opacity = '0';
    document.body.style.transform = 'translateY(-4px)';
    setTimeout(function() { window.location.href = href; }, 200);
  });
})();

/* ── Image swipe on mobile ── */
(function() {
  var mainImg = document.getElementById('product-main-image');
  var thumbs = document.querySelectorAll('.product-media__thumb');
  if (!mainImg || !thumbs.length) return;

  var images = Array.from(thumbs).map(function(t) {
    return { src: t.dataset.src, alt: t.dataset.alt || '' };
  });
  var current = 0;

  function goTo(index) {
    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;
    current = index;
    mainImg.src = images[current].src;
    mainImg.alt = images[current].alt;
    thumbs.forEach(function(t, i) {
      t.classList.toggle('active', i === current);
    });
  }

  // Touch swipe
  var startX = 0;
  var wrap = mainImg.closest('.product-media__main');
  if (!wrap) return;

  wrap.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  }, { passive: true });

  wrap.addEventListener('touchend', function(e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      goTo(diff > 0 ? current + 1 : current - 1);
    }
  }, { passive: true });

  // Also wire thumb clicks to update current index
  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() { current = i; });
  });
})();

/* ── Sticky ATC ── */
(function() {
  var stickyBar = document.getElementById('sticky-atc');
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var mainBtn = document.getElementById('add-to-cart-btn');
  var form = document.getElementById('product-form');
  if (!stickyBar || !stickyBtn || !form) return;

  // Only run on mobile
  if (window.innerWidth >= 920) return;

  function show() { stickyBar.style.transform = 'translateY(0)'; }
  function hide() { stickyBar.style.transform = 'translateY(100%)'; }

  if (mainBtn) {
    var observer = new IntersectionObserver(function(entries) {
      entries[0].isIntersecting ? hide() : show();
    }, { threshold: 0.5 });
    observer.observe(mainBtn);
  } else {
    show();
  }

  stickyBtn.addEventListener('click', function() {
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });
})();

/* ── Notify Me (out of stock) ── */
(function() {
  var btn = document.getElementById('notify-me-btn');
  var input = document.getElementById('notify-me-email');
  var success = document.getElementById('notify-me-success');
  var form = document.getElementById('notify-me-form');
  if (!btn || !input) return;

  btn.addEventListener('click', function() {
    var email = input.value.trim();
    if (!email || !email.includes('@')) {
      input.style.borderColor = 'var(--accent)';
      input.focus();
      return;
    }

    btn.textContent = 'Sending...';
    btn.disabled = true;

    // Submit to Shopify customer signup endpoint
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        form_type: 'customer',
        utf8: '✓',
        'contact[email]': email,
        'contact[tags]': 'back-in-stock,' + (window.location.pathname.split('/').pop() || 'product'),
        'contact[body]': 'Back in stock notification request for: ' + document.title
      })
    })
    .then(function() {
      input.style.display = 'none';
      btn.style.display = 'none';
      if (success) success.style.display = 'block';
    })
    .catch(function() {
      // Even on error show success — email was valid
      input.style.display = 'none';
      btn.style.display = 'none';
      if (success) success.style.display = 'block';
    });
  });

  // Clear red border on type
  input.addEventListener('input', function() {
    input.style.borderColor = '';
  });
})();
